<template>
  <transition name="product">
    <div class="scan-detail">
      <van-nav-bar
        @click-left="onClickLeft"
        :title="title"
        left-text="返回"
        left-arrow
      >
      </van-nav-bar>

      <component
        v-if="compshow"
        v-bind:is="currentTabComponent.components"
      ></component>
    </div>
  </transition>
</template>

<script>
const tabs = {
  chattelMortgageCheck: { title: "动产抵押详细信息", components: "chattelMortgageCheck", sort: 1 }, // 
  courtAnnoCheckDetail: { title: "开庭公告详情", components: "courtAnnoCheckDetail", sort: 2 },
  shiXinCheckDetail: { title: "失信详情", components: "shiXinCheckDetail", sort: 3 },
  zhiXingCheckDetail: { title: "被执行人详情", components: "zhiXingCheckDetail", sort: 4 },
  judgmentDocCheckDetail: { title: "裁判文书详情", components: "judgmentDocCheckDetail", sort: 5 },
  judicialSaleCheckDetail: { title: "司法拍卖详情", components: "judicialSaleCheckDetail", sort: 6 },
  equityPledgedCheckDetail: { title: "股权出质详情", components: "equityPledgedCheckDetail", sort: 7 },
  equityFreezeCheckDetail: { title: "股权冻结详情", components: "equityFreezeCheckDetail", sort: 8 },
  adminPenaltyCheckDetail: { title: "行政处罚详情", components: "adminPenaltyCheckDetail", sort: 9 },
  landMortgageCheckDetail: { title: "土地抵押详情", components: "landMortgageCheckDetail", sort: 10 },
  envPunishmentCheckDetail: { title: "环保处罚详情", components: "envPunishmentCheckDetail", sort: 11 },
  taxIllegalCheckDetail: { title: "税收违法详情", components: "taxIllegalCheckDetail", sort: 12 },
};
import chattelMortgageCheck from "./components/subChattelMortgage";
import courtAnnoCheckDetail from './components/detail/courtAnnoCheckDetail'
import shiXinCheckDetail from './components/detail/shiXinCheckDetail'
import zhiXingCheckDetail from './components/detail/zhiXingCheckDetail'
import judgmentDocCheckDetail from './components/detail/judgmentDocCheckDetail'
import judicialSaleCheckDetail from './components/detail/judicialSaleCheckDetail'
import equityPledgedCheckDetail from './components/detail/equityPledgedCheckDetail'
import equityFreezeCheckDetail from './components/detail/equityFreezeCheckDetail'
import adminPenaltyCheckDetail from './components/detail/adminPenaltyCheckDetail'
import landMortgageCheckDetail from './components/detail/landMortgageCheckDetail'
import envPunishmentCheckDetail from './components/detail/envPunishmentCheckDetail'
import taxIllegalCheckDetail from './components/detail/taxIllegalCheckDetail'
export default {
  components:{
    chattelMortgageCheck,
    courtAnnoCheckDetail,
    shiXinCheckDetail,
    zhiXingCheckDetail,
    judgmentDocCheckDetail,
    judicialSaleCheckDetail,
    equityPledgedCheckDetail,
    equityFreezeCheckDetail,
    adminPenaltyCheckDetail,
    landMortgageCheckDetail,
    envPunishmentCheckDetail,
    taxIllegalCheckDetail
  },
  data() {
    return {
      title: "",
      compshow: false,
      currentTabComponent: []
    };
  },
  methods: {
    onClickLeft() {},
  },
  created(){
    this.tabs = Object.assign({}, tabs);
    let key = this.$route.query.key;
    
    this.title = this.tabs[key].title;
    this.currentTabComponent = this.tabs[key];
    this.compshow = true;
  }
};
</script>

<style lang="scss" scoped>
.scan-detail {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
</style>